var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"catalogs"}},[(_vm.inventory)?_c('Datatable',{ref:"datatable",staticClass:"datatable",attrs:{"entity":"catalog","parameters":{inventory: _vm.inventory.id},"onRowClick":_vm.onRowClick,"globalActions":[
      {text: 'catalog.manage_company', method: _vm.goToCompanyCatalogs, condition: function() { return !_vm.$route.query.company}},
    ],"rowActions":[{text: 'datatable.edit', method: _vm.onRowEdit}]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }